var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52123 7.05493H2.47877C1.82161 7.05574 1.19159 7.31425 0.726912 7.77378C0.26223 8.23331 0.000813485 8.85634 0 9.50621V12H9V9.50621C8.99919 8.85634 8.73777 8.23331 8.27309 7.77378C7.8084 7.31425 7.17839 7.05574 6.52123 7.05493Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49966 6.08005C6.19745 6.08005 7.57378 4.71899 7.57378 3.04003C7.57378 1.36107 6.19745 0 4.49966 0C2.80187 0 1.42554 1.36107 1.42554 3.04003C1.42554 4.71899 2.80187 6.08005 4.49966 6.08005Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.443a0d8b6a13bd0323928793641e74e1.svg";
export { ForwardRef as ReactComponent };